import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { ContentProvider } from '@/types/knowledge';

interface ManageWorkflowProps {
    isOpen: boolean;
    onClose: () => void;
    provider: ContentProvider;
}

export const ManageWorkflow = ({ isOpen, onClose, provider }: ManageWorkflowProps) => {

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="bg-background">
                <DialogHeader>
                    <DialogTitle className="text-foreground">
                        Manage Workflow - {provider.name}
                    </DialogTitle>
                    <DialogDescription className="text-muted-foreground">
                        Workflow management will be implemented here in the future.
                    </DialogDescription>
                </DialogHeader>

                <div className="mt-4">
                    <p className="text-muted-foreground">
                        This component will be created later to manage the workflow for {provider.name}.
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    );
};
